<template>
  <el-form
    :model="form"
    :rules="rules"
    label-position="left"
    :validate-on-rule-change="false"
    ref="form"
    inline
    label-width="140px"
  >
    <el-row :gutter="24">
      <el-col :span="12" :xl="8" :lg="12" :md="24" :sm="24" :xs="24">
        <el-form-item label="TnC Type:" prop="tnCType">
          <el-select v-model="form.tnCType" style="width: 300px">
            <el-option
              v-for="option in tncArr"
              :key="option.value"
              :value="option.value"
              :label="option.label"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12" :xl="8" :lg="12" :md="24" :sm="24" :xs="24">
        <el-form-item label="TnC expiry date:" prop="tnCExpiryDate">
          <el-date-picker
            valueFormat="yyyy-MM-dd"
            format="yyyy-MM-dd"
            v-model="form.tnCExpiryDate"
            style="width: 300px"
          ></el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="12" :xl="8" :lg="12" :md="24" :sm="24" :xs="24">
        <el-form-item label="Status:" prop="status">
          <el-select v-model="form.status" style="width: 300px">
            <el-option
              v-for="option in status"
              :key="option.value"
              :value="option.value"
              :label="option.label"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12" :xl="8" :lg="12" :md="24" :sm="24" :xs="24">
        <el-form-item label="Action:" prop="action">
          <el-select v-model="form.action" style="width: 300px">
            <el-option
              v-for="option in actions"
              :key="option.value"
              :value="option.value"
              :label="option.label"
            />
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
export default {
  name: 'common-form',
  data() {
    const tncArr = [
      { value: 1, label: 'Critical' },
      { value: 2, label: 'Maintenance' },
      { value: 3, label: 'Operational' },
    ]
    const status = [
      { value: 1, label: 'Not Satisfied' },
      { value: 2, label: 'Satisfied' },
    ]
    const actions = [
      { value: 1, label: 'Active' },
      { value: 2, label: 'Inactive' },
    ]
    return {
      form: {
        tnCType: '',
        tnCExpiryDate: '',
        status: '',
        action: '',
      },
      rules: {
        tnCType: [
          { required: true, message: 'can not be empty!', trigger: 'blur' },
        ],
        tnCExpiryDate: [
          { required: true, message: 'can not be empty!', trigger: 'blur' },
        ],
        status: [
          { required: true, message: 'can not be empty!', trigger: 'blur' },
        ],
        action: [
          { required: true, message: 'can not be empty!', trigger: 'blur' },
        ],
      },
      tncArr,
      status,
      actions,
    }
  },
  methods: {
    getCommonForm() {
      return { ...this.form }
    },
    async checkCommonValid() {
      return await this.$refs.form.validate()
    },
  },
  props: {
    defaultData: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    defaultData: {
      deep: true,
      immediate: true,
      handler(newValue) {
        if (newValue) {
          const _form = {}
          const newValueKeys = Object.keys(newValue)
          Object.keys(this.form).forEach(key => {
            if (newValueKeys.indexOf(key) !== -1) {
              _form[key] = newValue[key]
            }
          })
          this.form = _form
        }
      },
    },
  },
}
</script>

<style scoped lang="less"></style>
